<section class="cmn-innerpage-wrapper invoice-details">
  <div class="head">
    <div class="search-wrapper">
      <input
        type="text"
        class="cmn-header-search"
        placeholder="Search"
        (input)="onSearch($event)"
      />
    </div>
    <button
      class="cmn-add-btn"
      (click)="navigateTo('vendor-invoice/vendor-invoice-new')"
      *ngIf="canAddBill$ | async"
    >
      <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> New Vendor
      Invoice
    </button>

    <!-- Filter -->
  </div>
  <div class="sub-head">
    <ul>
      <li class="main">All Vendor Invoices</li>
      <li
        *ngIf="isEditableStatus() && (canEditBill$ | async)"
        class="edit"
        (click)="navigateToEditPage()"

      >
        <img src="assets/images/icons/icon-edit-accounts.svg" alt="Edit" />
        Edit
      </li>

      <li *ngIf="isEditableStatus()" class="delete" (click)="onRemoveInvoice()">
        <img src="assets/images/icons/icon-delete-li.svg" alt="Delete" />
        Cancel
      </li>

       <li *ngIf="invoiceData?.billStatus === 'Approved'" class="edit" (click)="onViewDocument()">
        <img src="assets/images/icons/icon-pdf.svg" alt="PDF" />
        PDF
      </li> 
    </ul>

    <!-- <div class="mat-menu-wrapper">
      <button
        mat-icon-button
        [matMenuTriggerFor]="menu"
        aria-label="Example icon-button with a menu"
        *ngIf="invoiceData?.invoiceStatus === 'Approved'"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="markAsSent()">
          <span>Mark as Sent</span>
        </button>
      </mat-menu>
    </div> -->
  </div>
  <div class="manual-journal-details-tab-wrapper">
    <div class="tab-left">
      <div class="tab-box-main-wrapper">
        <button
          *ngFor="let bill of allInvoices; let i = index"
          class="tab-custom-button"
          [class.active]="selectedTabIndex === i"
          (click)="selectTab(i)"
        >
          <div class="inn-box">
            <h2>
              {{ bill?.vendorData?.vendorName }}
            </h2>
            <h3>{{ bill?.billNo }}</h3>
          </div>
          <div class="inn-box">
            <h6>{{ bill?.billDate | date : "dd MMM yyyy" }}</h6>
            <h5>{{ bill?.billStatus }}</h5>
          </div>
          <div class="inn-box">
            <!-- <h4 class="grey">{{ bill?.orderData?.orderCode }}</h4> -->
          </div>
        </button>
      </div>
    </div>
    <div class="manual-journal-details-content-wrapper">
      <div>
        <div class="chart-tab-content">
          <div class="tab-container">
            <div class="tab-inner">
              <div class="note-header">
                <div class="left-set">
                  <div>
                    <div>
                      <h4>{{ invoiceData?.vendorData?.address }}</h4>
                    </div>
                  </div>
                </div>
                <div class="right-set">
                  <h2>VENDOR INVOICE</h2>
                  <h3>#{{ invoiceData?.billNo }}</h3>
                  <h3>{{ invoiceData?.billDate | date : "dd/MM/YYYY" }}</h3>
                </div>
              </div>

              <div class="journal-details">
                <div class="right-set">
                  <div class="details-box">
                    <h5>Balance Due</h5>
                    <h6>AED {{ invoiceData?.balance | number : "1.2-2" }}</h6>
                  </div>
                </div>
              </div>
              <div class="page-footer-content">
                <div class="right-set">
                  <div class="details-box">
                    <h4>Bill from</h4>
                    <h5>:</h5>
                    <h6>{{ invoiceData?.vendorData?.vendorName }}</h6>
                  </div>
                  <!-- <div class="details-box">
                    <h4>PO Number</h4>
                    <h5>:</h5>
                    <h6>
                      {{
                        invoiceData?.purchaseOrderData?.purchaseOrderNo || "--"
                      }}
                    </h6>
                  </div> -->
                  <div class="details-box">
                    <h4>Bill Date</h4>
                    <h5>:</h5>
                    <h6>{{ invoiceData?.billDate | date : "dd/MM/YYYY" }}</h6>
                  </div>
                  <div class="details-box">
                    <h4>Due Date</h4>
                    <h5>:</h5>
                    <h6>{{ invoiceData?.dueDate | date : "dd/MM/YYYY" }}</h6>
                  </div>
                </div>
              </div>
              <div class="crdit-note-page-table">
                <table>
                  <tr>
                    <th>Sl No.</th>
                    <th>Item</th>
                    <th>Description</th>
                    <th>Qty</th>
                    <th>Rate</th>
                    <th>Sub Total</th>
                    <th>VAT(5%)</th>
                    <th>Total Amount</th>
                  </tr>
                  <tr
                    *ngFor="let item of invoiceData?.billItems; let i = index"
                  >
                    <td>{{ i + 1 }}</td>
                    <td>{{ item?.itemName }}</td>
                    <td>{{ item?.description }}</td>
                    <td>{{ item?.quantity }}</td>
                    <td>AED {{ item?.rate }}</td>
                    <td>AED {{ item?.subTotal }}</td>
                    <td>AED {{ item?.tax }}</td>
                    <td>AED {{ item?.totalAmount }}</td>
                  </tr>
                </table>
              </div>
              <div class="page-footer-content">
                <div class="right-set">
                  <div class="details-box">
                    <h4>Sub total</h4>
                    <h5>:</h5>
                    <h6>AED {{ invoiceData?.subTotal | number : "1.2-2" }}</h6>
                  </div>
                  <div class="details-box">
                    <h4>VAT(5%)</h4>
                    <h5>:</h5>
                    <h6>AED {{ invoiceData?.tax | number : "1.2-2" }}</h6>
                  </div>
                  <div class="details-box">
                    <h4>Total</h4>
                    <h5>:</h5>
                    <h6>
                      AED {{ invoiceData?.totalAmount | number : "1.2-2" }}
                    </h6>
                  </div>
                </div>
              </div>

              <p
                *ngIf="
                  invoiceData?.billStatus === 'Approved' ||
                  invoiceData?.billStatus === 'Rejected'
                "
                class="approvedBy"
              >
                {{ invoiceData?.isApproved ? "Approved By" : "Rejected By" }} :
                {{ invoiceData?.approvedOrRejectedBy }}
              </p>
              <p class="signature">Authorized Signature <span></span></p>
              <span
                class="published-note"
                *ngIf="invoiceData?.billStatus === 'Open'"
                ><img src="assets/images/img-open.svg" alt="Open"
              /></span>
              <span
                class="published-note"
                *ngIf="invoiceData?.billStatus === 'Draft'"
                ><img src="assets/images/img-draft.svg" alt="Draft"
              /></span>
              <span
                class="published-note"
                *ngIf="invoiceData?.billStatus === 'Cancelled'"
                ><img src="assets/images/img-cancelled.svg" alt="Cancel"
              /></span>
              <span
                class="published-note"
                *ngIf="invoiceData?.billStatus === 'Paid'"
                ><img src="assets/images/img-closed.svg" alt="Paid"
              /></span>
              <!-- <span
                class="published-note"
                *ngIf="invoiceData?.billStatus === 'Paid'"
                ><img src="assets/images/img-overdue.svg" alt="Overdue"
              /></span> -->
            </div>
          </div>

          <div
            class="invoice-details-footer-wrapper"
            *ngIf="invoiceData?.billStatus === 'Pending' && (canApproveReject$ | async)"
          >
            <div class="submit-btn-wrapper">
              <button
                class="cmn-next-btn"
                type="button"
                (click)="handleApproval(true, invoiceData.id)"
              >
                Approve
              </button>
              <button
                class="cmn-next-btn"
                type="button"
                (click)="handleApproval(false, invoiceData.id)"
              >
                Reject
              </button>
            </div>
          </div>
          <div
            *ngIf="invoiceData?.billStatus === 'Approved'"
            class="credit-note-footer-table-wrapper"
          >
            <table>
              <tr class="title">
                <td>
                  {{
                    "Journal No" + " : " + invoiceData?.journalData?.journalNo
                  }}
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>Account</td>
                <td>Debit</td>
                <td>Credit</td>
              </tr>
              <tr
                class="bold"
                *ngFor="
                  let entry of invoiceData?.journalData?.journalEntries || []
                "
              >
                <td>
                  {{ entry?.accountData?.accountName }}
                </td>
                <td>AED {{ entry.debit | number : "1.2-2" }}</td>
                <td>AED {{ entry.credit | number : "1.2-2" }}</td>
              </tr>
              <hr />
              <tr class="bold">
                <td></td>
                <td>AED {{ getDebitTotal() | number : "1.2-2" }}</td>
                <td>AED {{ getCreditTotal() | number : "1.2-2" }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
